var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateSyncStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.61,
    height: 15.61,
    viewBox: "0 0 15.61 15.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "update_1_",
    "data-name": "update (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M156.921,12.543h-.212A7.807,7.807,0,0,0,147.468.614a.457.457,0,1,0,.356.842,6.893,6.893,0,0,1,8.333,10.294.457.457,0,0,0-.913.031V13a.457.457,0,0,0,.457.457h1.219a.457.457,0,0,0,0-.915Z",
    transform: "translate(-142.701 0)",
    fill: "#c6cad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M10.487,82.589A6.892,6.892,0,0,1,2.154,72.3a.457.457,0,0,0,.913-.032v-1.22a.457.457,0,0,0-.457-.457H1.39a.457.457,0,0,0,0,.915H1.6a7.807,7.807,0,0,0,9.24,11.93.457.457,0,1,0-.356-.842Z",
    transform: "translate(0 -68.435)",
    fill: "#c6cad7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M90.388,88.448a4.528,4.528,0,0,0,.307-.74h.518a.457.457,0,0,0,.457-.457V85.421a.457.457,0,0,0-.457-.457H90.7a4.528,4.528,0,0,0-.307-.74l.367-.367a.457.457,0,0,0,0-.647l-1.294-1.294a.457.457,0,0,0-.647,0l-.367.367a4.528,4.528,0,0,0-.74-.307v-.518A.457.457,0,0,0,87.25,81H85.421a.457.457,0,0,0-.457.457v.518a4.531,4.531,0,0,0-.74.307l-.367-.367a.457.457,0,0,0-.647,0l-1.293,1.294a.457.457,0,0,0,0,.647l.367.367a4.528,4.528,0,0,0-.308.74h-.518a.457.457,0,0,0-.457.457V87.25a.457.457,0,0,0,.457.457h.518a4.527,4.527,0,0,0,.308.74l-.367.367a.457.457,0,0,0,0,.647l1.293,1.294a.457.457,0,0,0,.647,0l.367-.367a4.531,4.531,0,0,0,.74.307v.518a.457.457,0,0,0,.457.457H87.25a.457.457,0,0,0,.457-.457V90.7a4.531,4.531,0,0,0,.74-.308l.367.367a.457.457,0,0,0,.647,0l1.294-1.294a.457.457,0,0,0,0-.647Zm-4.053.327a2.439,2.439,0,1,1,2.439-2.439A2.442,2.442,0,0,1,86.335,88.774Z",
    transform: "translate(-78.53 -78.53)",
    fill: "#c6cad7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateSyncStatus);
export default __webpack_public_path__ + "static/media/update-sync-status.2370464d5926b9ed896c64d45c0c6d47.svg";
export { ForwardRef as ReactComponent };